import { Controller } from "stimulus"
import { debounce, nextFrame } from "../helpers"

export default class extends Controller {
  static targets = ["promptInput", "update"]

  static values = { url: String, placeholders: Array }

  initialize() {
    this.update = debounce(this.update.bind(this), 60)
    this.updatePreview = debounce(this.update, 1200)
    nextFrame().then(() => this.selectPromptPlaceholder())
  }

  selectPromptPlaceholder(event) {
    const input = this.promptInputTarget
    if (!input.value) return

    for (const placeholder of this.placeholdersValue) {
      const index = input.value.indexOf(placeholder)
      if (index < 0) continue

      input.focus()
      input.setSelectionRange(index, index + placeholder.length)
      return event?.preventDefault()
    }
  }

  async update() {
    const html = await fetch(this.url).then((resp) => resp.text())
    const root = new DOMParser().parseFromString(html, "text/html")

    const selector = `[data-${this.identifier}-target~="update"]`
    const elements = [...root.querySelectorAll(selector)]

    await nextFrame()

    for (const target of this.updateTargets) {
      const element = elements.shift() || target
      if (target.isEqualNode(element)) continue
      if (target.contains(document.activeElement)) continue
      target.replaceWith(element)
    }
  }

  get url() {
    const url = new URL(this.urlValue, location)
    for (const [key, value] of this.formData) {
      if (!key.match(/token/)) {
        url.searchParams.append(key, value)
      }
    }
    return url
  }

  get formData() {
    return new FormData(this.element)
  }
}
